<div  class="sticky d-none d-sm-block">
  <header class="header">
    <div class="row justify-content-between align-items-center">
      <img src="/assets/images/pwc_logo.svg" (click)="goHome()" class="logo ps-3 pointer" />
      <div class="sep vertical ms-3 me-3 align-self-center"></div>
      @if (secondaryLogo && viewSize > 3) {
        <div class="d-inline-block col-auto secondary-logo-wrapper">
          <img [src]="secondaryLogo" alt="" class="logo-secondary" />
        </div>
        <div class="sep vertical ms-3 me-3"></div>
      }
      @if (viewSize > 3) {
        <div class="title col-auto pointer d-flex flex-row align-items-center" (click)="goHome()">
          <!-- <div class="me-2" style="margin-bottom: -7px">Bandi e Incentivi</div>
          <img src="/assets/images/bandi-e-incentivi.svg" class="logo align-self-end">-->
          <!-- CANALE DIRETTO -->
          @if (directChannel) {
            <span class="me-2">{{
              "header.title.piattaforma-italia" | translate
            }}</span>
            <!-- <img src="/assets/images/bandi-e-incentivi.svg" class="logo align-self-end"> -->
          }
          <!-- CANALE BANCA -->
          @if (!directChannel) {
            <span class="me-2">{{ "header.title.bei" | translate }}</span>
            <!-- <img src="/assets/images/bandi-e-incentivi.svg" class="logo align-self-end"> -->
          }
        </div>
      }
      <div>
        <a class="color-orange handPointer" (click)="getB2CManual()">
          <img src="/assets/images/icons/manual_b2c.svg" ngbTooltip="{{'header.user-manual' | translate }}"
            class="small-icon color-icon">
        </a>
      </div>

      @if (!environment.hideSelectedSociety) {
        <div class="welcomeText col-auto px-2">
          @if (societiesService.getSelectedSociety() | async) {
            <span>{{
              (societiesService.getSelectedSociety() | async).name
            }}</span>
          }
        </div>
      }

      <!-- Separator -->
      @if (!environment.hideSelectedSociety) {
        <div class="sep vertical"></div>
      }

      <div class="welcomeUserText col-auto px-2">
        {{ "header.welcome-message" | translate }} <br />@if (user) {
        <span>{{ user.firstName }} {{ user.lastName
        }}</span>
      }
    </div>
    <!-- Notifications -->
    <div class="notification-bell align-self-center baloon trasparent" (click)="showNotificationPanel = true"
        [ngbTooltip]="
          (notificationInfo.notificationCount > 0
            ? 'header.notification.new-notification'
            : 'header.notification.no-new-notification'
          ) | translate
        ">
      <pwc-icon name="bell_black" class="notification-image"></pwc-icon>
    </div>
    <!-- Number of notifications -->
    @if (notificationInfo.notificationCount > 0 && viewSize > 2) {
      <span class="badge badge-primary badge-pill pointer" (click)="showNotificationPanel = true"
        >
        {{
        notificationInfo.notificationCount > 9
        ? "9+"
        : notificationInfo.notificationCount
        }}
      </span>
    }

    <!-- Separator -->
    @if (environment.configuration.multilanguage) {
      <div class="sep vertical ms-3 me-3"></div>
    }

    <!-- *** FIELD language STARTS *** -->
    @if (environment.configuration.multilanguage) {
      <div class="col-lg-4 col-md-6 col-sm-12">
        <ul class="navbar-nav ">
          <li class="nav-item dropdown" ngbDropdown>
            <a class="nav-link dropdown-toggle pointer" ngbDropdownToggle>
              <span class="header-opts" translate>{{currentLanguage}}</span>
              <fa-icon class="ps-1" [icon]="faChevronDown"></fa-icon>
            </a>
            <div class="dropdown-menu" ngbDropdownMenu>
              @for (locale of availableLanguages(); track locale) {
                <a class="dropdown-item pointer" [translate]="locale"
                (click)="changeLanguage(locale)"></a>
              }
            </div>
          </li>
        </ul>
      </div>
    }
    <!-- *** FIELD language ENDS *** -->

    <!-- Separator -->
    <div class="sep vertical ms-3 me-3"></div>

    <!-- Profile -->
    <div style="margin-right: 10px;" class="d-inline-block pointer align-self-center" ngbDropdown #myDrop="ngbDropdown"
      display="dynamic" (click)="notificationPanel? notificationPanel.closePanel() : null" placement="bottom-right">
      <div class="baloon" ngbDropdownToggle id="dropdownManual">
        {{ userInitials | uppercase }}
      </div>
      <div ngbDropdownMenu aria-labelledby="dropdownManual">
        <!-- home b2b -->
        <button ngbDropdownItem
          class="d-flex flex-row  w-100"
            *canAccess="[
              AuthorityCodeEnum.ROLE_BANDI_B2B_ACCESS,
              AuthorityCodeEnum.ROLE_INCENTIVI_B2B_ACCESS,
            ]" (click)="executeIfNotInVideoConference('goToHomepageB2B')">
          {{ "header.dropdown-menu.b2b" | translate }}
        </button>
        <!-- change society -->
        @if (showSocietySelectionLink) {
          <button ngbDropdownItem class="d-flex flex-row  w-100"  routerLink="/society-selection">
            {{ "header.dropdown-menu.change-society" | translate }}
          </button>
        }
        <!-- home -->
        @if (!currentlyInHome()) {
          <button ngbDropdownItem class="d-flex flex-row  w-100" (click)="goHome()">
            <pwc-icon class="fill-darkgrey" name="home"></pwc-icon>
            <span class="header-opts">{{
              "header.dropdown-menu.homepage" | translate
            }}</span>
          </button>
        }
        <!-- change psw -->
        <button ngbDropdownItem class="d-flex flex-row w-100" (click)="goToChangePassword()">
          <pwc-icon class="fill-darkgrey" name="settings"></pwc-icon>
          <span class="header-opts">
          {{ "header.dropdown-menu.change-psw" | translate }}</span>
        </button>
        <!-- service request list -->
        @if (!hideForPrivacy && !currentlyInEsg() && !currentlyInBandi() && !currentlyInIncentivi() && !directChannelLimited && environment.directChannel) {
          <button ngbDropdownItem class="d-flex flex-row w-100" (click)="goToServiceRequestList()"
            >
            <pwc-icon class="fill-darkgrey" name="survey_checkmark"></pwc-icon>
            <span class="header-opts">{{
              "header.dropdown-menu.service-req-list" | translate
            }}</span>
          </button>
        }
        <!-- BANDI MENU -->
        @if (
          !hideForPrivacy &&
          !currentlyInHome() &&
          !currentlyInEsg() &&
          !currentlyInIncentivi() &&
          currentlyInBandi()
          ) {
          <button ngbDropdownItem class="d-flex flex-row  w-100" (click)="executeIfNotInVideoConference('goToBandi')">
            <pwc-icon class="fill-darkgrey" name="4_quadrants"></pwc-icon>
            <span class="header-opts">{{
              "header.dropdown-menu.bandi-list" | translate
            }}</span>
          </button>
        }

        <!-- INCENTIVI MENU -->
        @if (
          !hideForPrivacy &&
          !currentlyInHome() &&
          !currentlyInEsg() &&
          !currentlyInBandi() &&
          currentlyInIncentivi()
          ) {
          <button ngbDropdownItem class="d-flex flex-row  w-100" (click)="executeIfNotInVideoConference('goToIncentivi')">
            <pwc-icon class="fill-darkgrey" name="4_quadrants"></pwc-icon>
            <span class="header-opts">{{
              "header.dropdown-menu.incentivi-list" | translate
            }}</span>
          </button>
        }

        <!-- preventivi -->
        @if (!hideForPrivacy && !isUserSmart && !currentlyInHome() && !currentlyInEsg() && (currentlyInBandi() || currentlyInIncentivi())) {
          <button ngbDropdownItem class="d-flex flex-row  w-100"
            *canAccess="[AuthorityCodeEnum.ROLE_BANDI_PRICE_QUOTE_B2C_READ]"
            (click)="executeIfNotInVideoConference('goToQuotation')">
            <pwc-icon class="fill-darkgrey" name="preventivo"></pwc-icon>
            <span class="header-opts">{{'header.dropdown-menu.quotation' + (currentlyInBandi() ? '-bandi' :
            '-incentivi') | translate}}</span>
          </button>
        }
        <!-- pratiche -->
        @if (!hideForPrivacy && !isUserSmart && !currentlyInHome() && !currentlyInEsg() &&  (currentlyInBandi() || currentlyInIncentivi())) {
          <button ngbDropdownItem class="d-flex flex-row  w-100" *canAccess="[AuthorityCodeEnum.ROLE_BANDI_PROJECT_B2C_READ]"
            (click)="executeIfNotInVideoConference('goToProject')">
            <pwc-icon class="fill-darkgrey" name="survey_checkmark"></pwc-icon>
            <span class="header-opts">{{'header.dropdown-menu.project' + (currentlyInBandi() ? '-bandi' : '-incentivi')
            | translate}}</span>
          </button>
        }
        <!-- richieste assistenza -->
        @if ((!directChannelLimited && (currentlyInHome() || currentlyInThematicArea())) || (!currentlyInHome() && !currentlyInEsg() &&  (currentlyInBandi() || currentlyInIncentivi()))) {
          <button ngbDropdownItem class="d-flex flex-row w-100" *canAccess="[AuthorityCodeEnum.ROLE_BANDI_RDA_CREATE]"
            (click)="executeIfNotInVideoConference('goToHelpDesk')">
            <pwc-icon class="fill-darkgrey" name="survey_checkmark"></pwc-icon>
            <span class="header-opts">{{
              "header.dropdown-menu.help-desk" | translate
            }}</span>
          </button>
        }
        <!-- richieste compatibilità -->
        @if (!currentlyInHome() && !currentlyInEsg() &&  (currentlyInBandi() || currentlyInIncentivi())) {
          <button ngbDropdownItem class="d-flex flex-row  w-100" *canAccess="[AuthorityCodeEnum.ROLE_BANDI_RDP_B2C_READ]"
            (click)="executeIfNotInVideoConference('goToRdpList')">
            <pwc-icon class="fill-darkgrey" name="survey_checkmark">
            </pwc-icon>
            <span class="header-opts">{{'header.dropdown-menu.rdp' | translate}}</span>
          </button>
        }
        <!-- live assistant -->
        @if (liveAssistantEnbaled && widgetLiveAssistantEnabled) {
          <button ngbDropdownItem class="d-flex flex-row  w-100" routerLink="/live-assistant"
            >
            <pwc-icon class="fill-darkgrey" name="meeting"></pwc-icon>
            <span class="header-opts">{{
              "header.dropdown-menu.meeting" | translate
            }}</span>
          </button>
        }
        <!-- user -->
        @if (!directChannelLimited) {
          <button ngbDropdownItem *canAccess="[AuthorityCodeEnum.ROLE_BANDI_PROFILE_UPDATE]" class="d-flex flex-row  w-100"
            routerLink="/user-profile">
            <pwc-icon class="fill-darkgrey" name="profilo">
            </pwc-icon>
            <span class="header-opts">{{'header.dropdown-menu.user-profile' | translate}}</span>
          </button>
        }

        <!-- rdp list -->
        <ng-container *canAccess="[AuthorityCodeEnum.ROLE_BANDI_RDP_CREATE]">
          @if (false) {
            <button ngbDropdownItem class="d-flex flex-row w-100" routerLink="/rdp/list">
              <pwc-icon class="fill-darkgrey"> </pwc-icon>
              <span class="header-opts">{{
                "header.dropdown-menu.rdp-list" | translate
              }}</span>
            </button>
          }
        </ng-container>
        <!-- delegate list -->
        @if (showDelegateForm ) {
          <button ngbDropdownItem class="d-flex flex-row  w-100" routerLink="/delegate/list"
            *canAccess="[AuthorityCodeEnum.ROLE_DELEGATE_CREATE]">
            <img src="/assets/images/icons/user_delegate.svg" class="mb-1 delegate-icon" />
            <span class="header-opts">{{
              "header.dropdown-menu.delegate-list" | translate
            }}</span>
          </button>
        }
        <!-- logout -->
        <button ngbDropdownItem class="d-flex flex-row w-100" (click)="logout()">
          <pwc-icon class="fill-darkgrey" name="logout"> </pwc-icon>
          <span class="header-opts">{{
            "header.dropdown-menu.logout" | translate
          }}</span>
        </button>
      </div>
    </div>
  </div>
</header>
<div class="col">
  <div class="row" style="flex-wrap: nowrap">
    <div>
      @if (showNotificationPanel) {
        <app-notifications-panel [notificationInfo]="this.notificationInfo" (onClosePanel)="showNotificationPanel = false"
          #notificationPanel>
        </app-notifications-panel>
      }
    </div>
    <div>
      @if (enableDownloadQueue) {
        <app-downloader-queue></app-downloader-queue>
      }
    </div>
  </div>
</div>

<pwc-confirmation-modal #sessionTimeoutModal [id]="'sessionTimeoutModal'"
  title="{{ 'confirm-modal.warning-title' | translate }}" [message]="timeoutCountDownMessage"
  [positiveButtonText]="null" negativeButtonText="{{ 'confirm-modal.cancel-btn' | translate }}"
  (negativeButtonClick)="onTimeoutStopConfirmed()">
</pwc-confirmation-modal>

<pwc-modal #startupMessageModal [id]="'startupMessageModal'">
  <div modal-title>
    <h5>{{ "confirm-modal.warning-title" | translate }}</h5>
  </div>

  <div modal-body>
    <div >
      <div >
        <p class="startup-message-text" [innerHTML]="startupMessage"></p>
      </div>
    </div>
  </div>

  <div modal-footer class="text-end">
    <button type="button" class="btn btn-action btn-success ms-2" (click)="startupMessageModal.close()">
      {{ "confirm-modal.confirm-btn" | translate }}
    </button>
  </div>
</pwc-modal>



<app-upgrade-plan-header></app-upgrade-plan-header>


<!-- Area Education  -->
<app-education-side-buttons></app-education-side-buttons>
</div>

<!-- HAMBURGER MENU -->
<div  class="sticky d-block d-sm-none">
  <nav class="navbar navbar-light bg-light navbar-fixed-top px-3">
    <div class = "container-fluid w-100 align-items-center">
      <div class="d-flex d-flex-row justify-content-between w-100">
        <a class="navbar-brand custom-header-navbar d-flex d-flex-row align-items-center w-fitcontent" href="home">
          <img src="/assets/images/pwc_logo_cut.svg" (click)="goHome()" class="logo pointer" />
          @if (directChannel) {
            <span class="ps-3 me-2 h3">{{
              "header.title.piattaforma-italia" | translate
            }}</span>
            <!-- <img src="/assets/images/bandi-e-incentivi.svg" class="logo align-self-end"> -->
          }
          <!-- CANALE BANCA -->
          @if (!directChannel) {
            <span class="ps-3 me-2 h3">{{ "header.title.bei" | translate }}</span>
            <!-- <img src="/assets/images/bandi-e-incentivi.svg" class="logo align-self-end"> -->
          }
        </a>
        @if (!openMenu) {
          <button
            class="navbar-toggler custom-navbar-toggler custom-header-navbar"
            type="button"
            (click)="openMenu = true"
            aria-expanded="false"
            aria-controls="navbarScroll"
            aria-label="Toggle navigation">
            <span [ngClass]="{'close' : openMenu, 'navbar-toggler-icon': !openMenu}"></span>
          </button>
        }
        @if (openMenu) {
          <button
            type="button"
            (click)="openMenu = false"
            class="navbar-toggler custom-navbar-toggler custom-header-navbar close"
            aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        }
      </div>



      @if (openMenu) {
        <div class="navbar-collapse w-100 light-color " id="navbarScroll">
          <ul class="navbar-nav me-auto py-3 custom-scroll-navbar">
            <!-- society and name -->
            <li class="nav-item row col-12 justify-content-between align-items-center">
              @if (!environment.hideSelectedSociety) {
                <ng-container ngbDropdownItem >
                  <div class="welcomeText col-6 align-self-center">
                    <a class="color-orange handPointer" (click)="openMenu = false; getB2CManual()">
                      <img src="/assets/images/icons/manual_b2c.svg"
                        class="small-icon color-icon">
                    </a>
                    @if (societiesService.getSelectedSociety() | async) {
                      <span class="header-opts">{{
                        (societiesService.getSelectedSociety() | async).name
                      }}</span>
                    }
                  </div>
                </ng-container>
              }
              <div class="welcomeUserText px-2 col-6">
                {{ "header.welcome-message" | translate }} <br />@if (user) {
                <span>{{ user.firstName }} {{ user.lastName
                }}</span>
              }
            </div>
          </li>
          @if (environment.configuration.multilanguage) {
            <hr>
            }
            <!-- language selector -->
            @if (environment.configuration.multilanguage) {
              <li class="nav-item row col-12 w-100 align-items-center">
                <div class="col-12 w-100">
                  <ul class="navbar-nav w-100 ">
                    <li class="nav-item dropdown w-100" ngbDropdown>
                      <a class="nav-link dropdown-toggle pointer" ngbDropdownToggle>
                        <img src="/assets/images/icons/languages.svg" class="upgrade-piano-icon">
                        <span class="header-opts" [translate]="currentLanguage"></span>
                      </a>
                      <div class="dropdown-menu" ngbDropdownMenu>
                        @for (locale of availableLanguages(); track locale) {
                          <a class="dropdown-item pointer" [translate]="locale"
                          (click)="changeLanguage(locale)"></a>
                        }
                      </div>
                    </li>
                  </ul>
                </div>
              </li>
            }
            <hr>
              <!-- action menu -->
              <!-- b2b -->
              <li class="nav-item row col-12 w-100 align-items-center">
                <button ngbDropdownItem
                  class="d-flex flex-row  w-100"
              *canAccess="[
                AuthorityCodeEnum.ROLE_BANDI_B2B_ACCESS,
                AuthorityCodeEnum.ROLE_INCENTIVI_B2B_ACCESS,
              ]" (click)="openMenu = false; executeIfNotInVideoConference('goToHomepageB2B')">
                  {{ "header.dropdown-menu.b2b" | translate }}
                </button>
              </li>
              <!-- change society -->
              <li class="nav-item row col-12 w-100 align-items-center">
                @if (showSocietySelectionLink) {
                  <button ngbDropdownItem class="d-flex flex-row  w-100"  (click)="openMenu = false;" routerLink="/society-selection">
                    {{ "header.dropdown-menu.change-society" | translate }}
                  </button>
                }
              </li>
              <!-- home -->
              <li class="nav-item row col-12 w-100">
                @if (!currentlyInHome()) {
                  <button ngbDropdownItem class="d-flex flex-row  w-100" (click)="openMenu = false; goHome()">
                    <pwc-icon class="fill-darkgrey" name="home"></pwc-icon>
                    <span class="header-opts">{{
                      "header.dropdown-menu.homepage" | translate
                    }}</span>
                  </button>
                }
              </li>
              <!-- change psw -->
              <li class="nav-item row col-12 w-100">
                <button ngbDropdownItem class="d-flex flex-row w-100" (click)="openMenu = false; goToChangePassword()">
                  <pwc-icon class="fill-darkgrey" name="settings"></pwc-icon>
                  <span class="header-opts">
                  {{ "header.dropdown-menu.change-psw" | translate }}</span>
                </button>
              </li>
              <!-- service request list -->
              <li class="nav-item row col-12 w-100">
                @if (!hideForPrivacy && !currentlyInEsg() && !currentlyInBandi() && !currentlyInIncentivi() && !directChannelLimited && environment.directChannel) {
                  <button ngbDropdownItem class="d-flex flex-row w-100" (click)="openMenu = false; goToServiceRequestList()"
                    >
                    <pwc-icon class="fill-darkgrey" name="survey_checkmark"></pwc-icon>
                    <span class="header-opts">{{
                      "header.dropdown-menu.service-req-list" | translate
                    }}</span>
                  </button>
                }
              </li>
              <!-- BANDI MENU -->
              <li class="nav-item row col-12 w-100">
                @if (
                  !hideForPrivacy &&
                  !currentlyInHome() &&
                  !currentlyInEsg() &&
                  !currentlyInIncentivi() &&
                  currentlyInBandi()
                  ) {
                  <button ngbDropdownItem class="d-flex flex-row  w-100" (click)="openMenu = false; executeIfNotInVideoConference('goToBandi')">
                    <pwc-icon class="fill-darkgrey" name="4_quadrants"></pwc-icon>
                    <span class="header-opts">{{
                      "header.dropdown-menu.bandi-list" | translate
                    }}</span>
                  </button>
                }
              </li>
              <!-- INCENTIVI MENU -->
              <li class="nav-item row col-12 w-100">
                @if (
                  !hideForPrivacy &&
                  !currentlyInHome() &&
                  !currentlyInEsg() &&
                  !currentlyInBandi() &&
                  currentlyInIncentivi()
                  ) {
                  <button ngbDropdownItem class="d-flex flex-row  w-100" (click)="openMenu = false; executeIfNotInVideoConference('goToIncentivi')">
                    <pwc-icon class="fill-darkgrey" name="4_quadrants"></pwc-icon>
                    <span class="header-opts">{{
                      "header.dropdown-menu.incentivi-list" | translate
                    }}</span>
                  </button>
                }
              </li>
              <!-- preventivi -->
              <li class="nav-item row col-12 w-100">
                @if (!hideForPrivacy && !isUserSmart && !currentlyInHome() && !currentlyInEsg() && (currentlyInBandi() || currentlyInIncentivi())) {
                  <button ngbDropdownItem class="d-flex flex-row  w-100"
                    *canAccess="[AuthorityCodeEnum.ROLE_BANDI_PRICE_QUOTE_B2C_READ]"
                    (click)="openMenu = false; executeIfNotInVideoConference('goToQuotation')">
                    <pwc-icon class="fill-darkgrey" name="preventivo"></pwc-icon>
                    <span class="header-opts">{{'header.dropdown-menu.quotation' + (currentlyInBandi() ? '-bandi' :
                    '-incentivi') | translate}}</span>
                  </button>
                }
              </li>
              <!-- pratiche -->
              <li class="nav-item row col-12 w-100">
                @if (!hideForPrivacy && !isUserSmart && !currentlyInHome() && !currentlyInEsg() &&  (currentlyInBandi() || currentlyInIncentivi())) {
                  <button ngbDropdownItem class="d-flex flex-row  w-100" *canAccess="[AuthorityCodeEnum.ROLE_BANDI_PROJECT_B2C_READ]"
                    (click)="openMenu = false; executeIfNotInVideoConference('goToProject')">
                    <pwc-icon class="fill-darkgrey" name="survey_checkmark"></pwc-icon>
                    <span class="header-opts">{{'header.dropdown-menu.project' + (currentlyInBandi() ? '-bandi' : '-incentivi')
                    | translate}}</span>
                  </button>
                }
              </li>
              <!-- richieste assistenza -->
              <li class="nav-item row col-12 w-100">
                @if ((!directChannelLimited && (currentlyInHome() || currentlyInThematicArea())) || (!currentlyInHome() && !currentlyInEsg() &&  (currentlyInBandi() || currentlyInIncentivi()))) {
                  <button ngbDropdownItem class="d-flex flex-row w-100" *canAccess="[AuthorityCodeEnum.ROLE_BANDI_RDA_CREATE]"
                    (click)="openMenu = false; executeIfNotInVideoConference('goToHelpDesk')">
                    <pwc-icon class="fill-darkgrey" name="survey_checkmark"></pwc-icon>
                    <span class="header-opts">{{
                      "header.dropdown-menu.help-desk" | translate
                    }}</span>
                  </button>
                }
              </li>
              <!-- richieste compatibilità -->
              <li class="nav-item row col-12 w-100">
                @if (!currentlyInHome() && !currentlyInEsg() &&  (currentlyInBandi() || currentlyInIncentivi())) {
                  <button ngbDropdownItem class="d-flex flex-row  w-100" *canAccess="[AuthorityCodeEnum.ROLE_BANDI_RDP_B2C_READ]"
                    (click)="openMenu = false; executeIfNotInVideoConference('goToRdpList')">
                    <pwc-icon class="fill-darkgrey" name="survey_checkmark">
                    </pwc-icon>
                    <span class="header-opts">{{'header.dropdown-menu.rdp' | translate}}</span>
                  </button>
                }
              </li>
              <!-- live assistant -->
              <!-- <li class="nav-item row col-12 w-100">
              <button ngbDropdownItem class="d-flex flex-row  w-100" (click)="openMenu = false;" routerLink="/live-assistant"
                *ngIf="liveAssistantEnbaled && widgetLiveAssistantEnabled">
                <pwc-icon class="fill-darkgrey" name="meeting"></pwc-icon>
                <span class="header-opts">{{
                  "header.dropdown-menu.meeting" | translate
                }}</span>
              </button>
            </li> -->
            <!-- user -->
            <li class="nav-item row col-12 w-100">
              @if (!directChannelLimited) {
                <button ngbDropdownItem *canAccess="[AuthorityCodeEnum.ROLE_BANDI_PROFILE_UPDATE]" (click)="openMenu = false;" class="d-flex flex-row  w-100"
                  routerLink="/user-profile">
                  <pwc-icon class="fill-darkgrey" name="profilo">
                  </pwc-icon>
                  <span class="header-opts">{{'header.dropdown-menu.user-profile' | translate}}</span>
                </button>
              }
            </li>
            <!-- rdp list -->
            <li class="nav-item row col-12 w-100">
              <ng-container *canAccess="[AuthorityCodeEnum.ROLE_BANDI_RDP_CREATE]">
                @if (false) {
                  <button ngbDropdownItem class="d-flex flex-row w-100" (click)="openMenu = false;" routerLink="/rdp/list">
                    <pwc-icon class="fill-darkgrey"> </pwc-icon>
                    <span class="header-opts">{{
                      "header.dropdown-menu.rdp-list" | translate
                    }}</span>
                  </button>
                }
              </ng-container>
            </li>
            <!-- delegate list -->
            <li class="nav-item row col-12 w-100">
              @if (showDelegateForm ) {
                <button ngbDropdownItem class="d-flex flex-row  w-100" (click)="openMenu = false;" routerLink="/delegate/list"
                  *canAccess="[AuthorityCodeEnum.ROLE_DELEGATE_CREATE]">
                  <img src="/assets/images/icons/user_delegate.svg" class="mb-1 delegate-icon" />
                  <span class="header-opts">{{
                    "header.dropdown-menu.delegate-list" | translate
                  }}</span>
                </button>
              }
            </li>
            <!-- logout -->
            <li class="nav-item row col-12 w-100">
              <button ngbDropdownItem class="d-flex flex-row w-100" (click)="openMenu = false; logout()">
                <pwc-icon class="fill-darkgrey" name="logout"> </pwc-icon>
                <span class="header-opts">{{
                  "header.dropdown-menu.logout" | translate
                }}</span>
              </button>
            </li>
            <!-- EDUCATION -->
            <hr>
              <li class="nav-item row col-12 w-100">
                <button ngbDropdownItem (click)="openMenu = false; checkPlanBeforeRedirect('education-area')" class="imgWhite w-100">
                  <img src="/assets/images/icons/education-outline.svg" class="upgrade-piano-icon">
                  <span class="header-opts">
                    {{'header.education-area'| translate}}
                  </span>
                </button>
              </li>
              <li class="nav-item row col-12 w-100">
                <button ngbDropdownItem (click)="openMenu = false; checkPlanBeforeRedirect('glossary')" class="imgWhite w-100" >
                  <img src="/assets/images/icons/glossario.svg" class="upgrade-piano-icon">
                  <span class="header-opts">
                    {{'header.glossary'| translate}}
                  </span>
                </button>
              </li>
              @if (liveAssistantEnbaled && widgetLiveAssistantEnabled) {
                <li class="nav-item row col-12 w-100">
                  <button
                    ngbDropdownItem
                    (click)="openMenu = false; goToVideoconferenceList()"
                    class="imgWhite w-100"
                    >
                    <img
                      src="/assets/images/icons/stewardship-outline.svg"
                      class="upgrade-piano-icon"
                      />
                    <span class="header-opts">
                      {{'header.live-assistant'| translate}}
                    </span>
                  </button>
                </li>
              }
              @if (isCoeSection || !isUserSmart) {
                <li class="nav-item row col-12 w-100">
                  <button ngbDropdownItem (click)="openMenu = false; checkPlanBeforeRedirect('faq')" >
                    <img src="/assets/images/icons/help-question-outline.svg" class="upgrade-piano-icon">
                    <span class="header-opts">
                      {{'header.faq'| translate}}
                    </span>
                  </button>
                </li>
              }
              @if (!isUserPremium && !currentlyInHome() && !currentlyInEsg() &&  (currentlyInBandi() || currentlyInIncentivi())) {
                <li class="nav-item row col-12 w-100">
                  <button ngbDropdownItem (click)="openMenu = false; openUpgradeModal() " >
                    <img src="/assets/images/icons/upgrade_piano_grey.svg" class="upgrade-piano-icon">
                    <span class="header-opts">
                      {{'header.upgrade'| translate}}
                    </span>
                  </button>
                </li>
              }
              <li class="nav-item row col-12 w-100 my-3"></li>
            </ul>
          </div>
        }
      </div>

    </nav>

  </div>

  <pwc-modal #upgradeMessageHeaderModal [id]="'upgradeMessageHeaderModal'">
    <div modal-title>
      <h5>{{ "header.startup-modal.title" | translate }}</h5>
    </div>

    <div modal-body>
      <div >
        <div >
          <p class="startup-message-text">
            {{ "header.startup-modal.message-1" | translate }}
            <br /><br />
            {{ "header.startup-modal.message-2" | translate }}
          </p>
        </div>
      </div>
    </div>

    <div modal-footer class="text-end">
      <button type="button" class="btn btn-action btn-success ms-2" (click)="upgradeMessageHeaderModal.close()">
        {{ "confirm-modal.confirm-btn" | translate }}
      </button>
    </div>
  </pwc-modal>

  <app-upgrade-plan-modal #upgradeModal></app-upgrade-plan-modal>


